import { signupActionTypes } from '../actions/signup-action-types';


const initialState = {
    signup: null,
    signupResult: null
};

export const signup = (state = initialState, action) => {


    switch (action.type) {

        case signupActionTypes.SIGNUP_REQUEST:
            return {
                ...state,
                signup: "requested"
            };

        case signupActionTypes.SIGNUP_SUCCESS:

            if(action.signupResult !== undefined && action.signupResult.errorMessage){
                return {
                    ...state,
                    signup: "failed",
                    signupResult: { errorMessage: action.signupResult.errorMessage }
                };
            } else {
                return {
                    ...state,
                    signup: "success",
                    signupResult: action.signupResult
                };
            }

        case signupActionTypes.SIGNUP_FAILED:
            return {
                ...state,
                signup: "failed",
                signupResult: { errorMessage: action.error.message }
            };

        default:
            return state

    }

}


// WEBPACK FOOTER //
// ./src/signup/reducers/signup-reducer.js